var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M41.2573 15.8714C41.2573 19.235 38.2807 23.5635 35.9573 26.8548C33.948 29.7009 32.8089 31.7714 29.9001 31.7714C26.9913 31.7714 25.8523 29.7009 23.843 26.8548C21.5195 23.5635 18.543 19.235 18.543 15.8714C18.543 9.59905 23.6277 3 29.9001 3C36.1725 3 41.2573 9.59905 41.2573 15.8714Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M29.9001 56C36.1725 56 41.2573 50.9152 41.2573 44.6429C41.2573 38.3705 36.1725 33.2857 29.9001 33.2857C23.6277 33.2857 18.543 38.3705 18.543 44.6429C18.543 50.9152 23.6277 56 29.9001 56ZM29.9001 50.7C33.2454 50.7 35.9573 47.9881 35.9573 44.6429C35.9573 41.2976 33.2454 38.5857 29.9001 38.5857C26.5548 38.5857 23.843 41.2976 23.843 44.6429C23.843 47.9881 26.5548 50.7 29.9001 50.7Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.329,
    height: 8.329,
    x: 25.357,
    y: 33.286,
    fill: "#2BCDE4",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.043,
    height: 8.329,
    x: 14,
    y: 27.229,
    fill: "#1868B7",
    rx: 4.164
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon (7).494be981ff0f43e22e35980633ff105e.svg";
export { ForwardRef as ReactComponent };